import LandingTemplate from './LandingTemplate';

export default LandingTemplate;